import { render, staticRenderFns } from "./SrBodyText.vue?vue&type=template&id=b1db1e92"
import script from "./SrBodyText.vue?vue&type=script&lang=js"
export * from "./SrBodyText.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports